// extracted by mini-css-extract-plugin
export default {"adminLogin":"AdminLogin_adminLogin__FdgKw"};